import React, { createContext, useContext, useState } from 'react';
import { translations } from './translations';

const LangCtx = createContext();

const LANGS = ['en', 'fr'];

function getLangFromPath() {
	const seg = window.location.pathname.split('/').filter(Boolean)[0];
	return LANGS.includes(seg) ? seg : 'en';
}

export function LangProvider({ children }) {
	const [lang, setLang] = useState(getLangFromPath);
	const t = (key) => {
		const keys = key.split('.');
		let val = translations[lang];
		for (const k of keys) val = val?.[k];
		return val ?? key;
	};
	return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
